import React, { FC, useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import { INotification } from '@provider/api/typing'
import {
  //getMyNotifications,
  readnotification,
} from '@provider/api/notifications'
import Box from '@mui/material/Box'
import parse from 'html-react-parser'
import Bell from '@brand/Icon/Bell'
import Button from '@mui/material/Button'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import Popover from '@mui/material/Popover'
import ArrowRight from '@mui/icons-material/ArrowRight'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Avatar from '@mui/material/Avatar'
import BellGrey from '@brand/Icon/BellGrey'
import useHeaderDetails from '@header/useHeaderDetails'
import useAdobeAnalytics from '@analytics/adobe'
import { getAvatarUrl } from '@util/api'
//import { error } from '@util/log'

const ProviderMessageNotifications: FC = () => {
  const [notificationData, setNotificationData] = useState<INotification[]>([])
  const [anchorElBell, setAnchorElBell] =
    React.useState<HTMLButtonElement | null>(null)
  const [hoverRow, setHoverRow] = React.useState<INotification | null>(null)
  const [anyNewNotifications, setAnyNewNotifications] = React.useState(false)
  const [newNotificationsCount, setNewNotificationsCount] = React.useState(0)
  const { login, role } = useHeaderDetails()
  const { trackLink } = useAdobeAnalytics()
  const messageTypes = ['Announcement', 'Product updates']
  const open = Boolean(anchorElBell)
  const id = open ? 'simple-popover' : undefined

  const handleClickBell = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElBell(event.currentTarget)
    trackLink(
      {
        name: 'Notifications preference',
        location: 'Main Content',
        type: 'internal',
        description: 'User can opt in or opt-out for email notifications',
      },
      {
        loginStatus: login ? 'logged in' : 'logged out',
        userType: role,
      }
    )
  }

  const handleCloseBell = () => {
    setAnchorElBell(null)
  }

  const filterDataNotification = (filter: any) => {
    //getMyNotifications(filter)
    //.then((data) => {
    setNotificationData([])
    isAnyNewNotifications([])
    //})
    //.catch((e) => error(e))
  }

  useEffect(() => {
    const filter = {
      notification_type: 'message',
      message_type: '',
    }
    filterDataNotification(filter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleMouseLeave = () => {
    if (hoverRow !== null) {
      if (!hoverRow?.read) {
        readnotification(hoverRow.id)
          .then(() => {
            const readNotificationData: INotification[] = notificationData.map(
              (nd) => (nd.id === hoverRow.id ? { ...nd, read: true } : nd)
            )
            setNotificationData(readNotificationData)
            isAnyNewNotifications(readNotificationData)
          })
          .catch((err: any) => {})
      }
    }
  }

  function isAnyNewNotifications(data: INotification[]) {
    setNewNotificationsCount(data.filter((item) => item.read === false).length)
    setAnyNewNotifications(
      data.filter((item) => item.read === false).length > 0 ? true : false
    )
  }

  return (
    <Box mt={-0.5}>
      <Button
        component="button"
        endIcon={!open ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        sx={({ ues }) => ({
          display: {
            xs: 'none',
            sm: 'none',
            md: 'flex',
            lg: 'flex',
            xl: 'flex',
          },
          mt: '1px',
          '&:hover': {
            background: ues.primary['5'],
          },
        })}
        onClick={handleClickBell}
      >
        {anyNewNotifications ? (
          <>
            <Bell
              sx={({ ues }) => ({ fill: ues.error['70'] })}
              height={'24px'}
              width={'24px'}
            />
            <Typography
              sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'flex',
                  lg: 'flex',
                  xl: 'flex',
                },
              }}
              variant="body2"
            >{`Notifications (${newNotificationsCount})`}</Typography>
          </>
        ) : (
          <>
            <BellGrey
              sx={({ ues }) => ({ fill: ues.neutral['80'] })}
              height={'24px'}
              width={'24px'}
            />
            <Typography
              sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'flex',
                  lg: 'flex',
                  xl: 'flex',
                },
              }}
              variant="body2"
            >{`Notifications`}</Typography>
          </>
        )}
      </Button>
      <Button
        component="button"
        sx={({ ues }) => ({
          display: {
            xs: 'flex',
            sm: 'flex',
            md: 'none',
            lg: 'none',
            xl: 'none',
          },
          mt: '1px',
          '&:hover': {
            background: ues.primary['5'],
          },
        })}
        onClick={handleClickBell}
      >
        {notificationData.length > 0 ? (
          <>
            <Bell
              sx={({ ues }) => ({
                ...(!anyNewNotifications && {
                  fill: ues.primary[70],
                }),
                ...(anyNewNotifications && {
                  fill: ues.error[70],
                }),
              })}
              height={'24px'}
              width={'24px'}
            />
            <Typography
              sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'flex',
                  lg: 'flex',
                  xl: 'flex',
                },
              }}
              variant="body2"
            >{`Notifications (${notificationData.length})`}</Typography>
          </>
        ) : (
          <>
            <Bell
              sx={({ ues }) => ({ fill: ues.neutral['80'] })}
              height={'24px'}
              width={'24px'}
            />
            <Typography
              sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'flex',
                  lg: 'flex',
                  xl: 'flex',
                },
              }}
              variant="body2"
            >{`Notifications`}</Typography>
          </>
        )}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorElBell}
        onClose={handleCloseBell}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box
          sx={{
            width: {
              xs: '348px',
              sm: '348px',
              md: '395px',
              lg: '395px',
              xl: '395px',
            },
          }}
        >
          <Box
            sx={({ ues }) => ({
              height: '5px',
              borderRadius: '5px 5px 0px 0px;',
              ...(!anyNewNotifications && {
                backgroundColor: ues.primary[70],
              }),
              ...(anyNewNotifications && {
                backgroundColor: ues.error[70],
              }),
            })}
          ></Box>
          <Box
            sx={({ ues }) => ({
              textAlign: 'center',
              padding: '22px 24px 22px 10px',
              borderTop: `1px solid ${ues.neutral['120']}`,
              borderBottom: `1px solid ${ues.neutral['120']}`,
            })}
          >
            <Typography
              variant="h5"
              sx={({ ues }) => ({ color: ues.neutral['90'], fontWeight: 700 })}
            >
              {`What's new in Match?`}
            </Typography>
          </Box>
          <Box>
            {' '}
            <>
              {' '}
              {messageTypes.map((mt, index) => (
                <Box key={index}>
                  {accordionTabs(
                    mt,
                    notificationData.filter(
                      (item) =>
                        item.messageType.toLowerCase() === mt.toLowerCase() &&
                        item.read === false
                    ).length
                  )}
                </Box>
              ))}
            </>
          </Box>
        </Box>
      </Popover>
    </Box>
  )

  function accordionTabs(type: string, counts: number) {
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowRight />}
          aria-controls={`${type.toLowerCase().replace(/ /g, '_')}-content`}
          id={`${type.toLowerCase().replace(/ /g, '_')}-header`}
        >
          {accordionTitles(type, counts)}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            display: 'flex',
            maxHeight: '50vh',
            overflowX: 'hidden',
            overflowY: 'scroll',
          }}
        >
          {loadTilesForNotifications(type)}
        </AccordionDetails>
      </Accordion>
    )
  }

  function loadTilesForNotifications(type: string) {
    return (
      <Box>
        {notificationData
          .filter(
            (item) => item.messageType.toLowerCase() === type.toLowerCase()
          )
          .map((row, i) => (
            <>
              <Box
                sx={{
                  width: {
                    xs: '331px',
                    sm: '331px',
                    md: '361px',
                    lg: '361px',
                    xl: '361px',
                  },
                  display: 'flex',
                  ml: -1,
                }}
                onMouseLeave={handleMouseLeave}
                onMouseEnter={() => setHoverRow(row)}
              >
                <Box sx={{ float: 'left', pr: 1, pt: 6 }}>
                  <Avatar
                    sx={({ ues }) => ({
                      ...(row.read && {
                        backgroundColor: 'transparent',
                        color: 'transparent',
                      }),
                      ...(!row.read && {
                        backgroundColor: ues.error[70],
                        color: ues.error[70],
                      }),
                      width: '10px',
                      height: '10px',
                    })}
                  >
                    .
                  </Avatar>
                </Box>
                <Box
                  sx={({ ues }) => ({
                    width: '100%',
                    borderRadius: '12px',
                    border: `1px solid ${ues.neutral['50']}`,
                    mb: 2,
                  })}
                >
                  {row.image !== null && (
                    <Box
                      component="img"
                      sx={{
                        borderTopLeftRadius: '12px',
                        borderTopRightRadius: '12px',
                        height: 253,
                        width: {
                          xs: '312px',
                          sm: '312px',
                          md: '342px',
                          lg: '342px',
                          xl: '342px',
                        },
                      }}
                      loading="lazy"
                      alt={row.messageTitle}
                      src={getAvatarUrl(
                        row.image?.thumbnailPath || row.image?.path || ''
                      )}
                    />
                  )}
                  <Box sx={{ padding: '24px 24px 0px 24px' }}>
                    <Typography variant="h5" pb={0.2}>
                      {row.messageTitle}
                    </Typography>
                    <Typography variant="body2" fontWeight={400} mt={-1} pb={2}>
                      {parse(row.messageDescription)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </>
          ))}
      </Box>
    )
  }

  function accordionTitles(title: string, counts: number) {
    return (
      <Box width={'100%'} display={'flex'}>
        <Box width={'90%'}>{title}</Box>
        {counts > 0 && (
          <Box>
            <Avatar
              sx={({ ues }) => ({
                backgroundColor: ues.error[70],
                color: ues.neutral[0],
                width: '25px',
                height: '25px',
              })}
            >
              <Typography
                variant="caption"
                sx={({ ues }) => ({ color: ues.neutral[0] })}
              >
                {counts}
              </Typography>
            </Avatar>
          </Box>
        )}
      </Box>
    )
  }
}

export default ProviderMessageNotifications
